import {create} from "@targoninc/jess";
import {page} from "./page.ts";
import {navbar} from "./navbar.ts";
import {searchModal} from "./search-modal.ts";
import {backToTop} from "./back-to-top.ts";
import {searchModalOpen} from "../lib/state.ts";

export function app() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
        if ((e.ctrlKey || e.metaKey) && e.key === "k") {
            e.preventDefault();
            searchModalOpen.value = true;
        }
    });

    return create("div")
        .classes("app", "relative", "flex")
        .children(
            navbar(),
            page(),
            searchModal(),
            backToTop()
        ).build();
}